import { responsibleUseContent } from '@/config/marketing-content/legal-pages'
import { LegalDocumentLayout } from '@/components/marketing/legal-document-layout'

export function ResponsibleUsePage() {
  return <LegalDocumentLayout document={responsibleUseContent} />
}
